import moment from 'moment'
import { map, mapValues, includes, filter } from 'lodash'
import immutable from 'object-path-immutable'

import {
  SET_PORTAL,
  CHANGE_PORTAL,
  ADD_PROMOTION,
  ADD_GALLERY_IMAGE,
  ADD_LINK,
  REMOVE_PROMOTION,
  ADD_LINK_IMAGE,
  REMOVE_LINK,
  REMOVE_IMAGE_LIST_ITEM,
} from '../constants/index'

export default (state = createInitState(), action) => {
  switch (action.type) {
    case SET_PORTAL:
      const portal = action.portal
      if (portal.coupons)
        portal.coupons = map(portal.coupons, coupon =>
          mapValues(coupon, (value, key) => {
            if (includes(dateFieldNames, key)) return moment(value)
            return value
          }),
        )

      if (portal.promotions)
        portal.promotions = map(portal.promotions, coupon =>
          mapValues(coupon, (value, key) => {
            if (includes(dateFieldNames, key)) return moment(value)
            return value
          }),
        )
      return portal

    case CHANGE_PORTAL:
      return immutable.set(state, action.path, action.value)

    case ADD_GALLERY_IMAGE:
      return {
        ...state,
        galleryImages: [
          {
            mainImageId: action.ref,
          },
          ...(state.galleryImages || []),
        ],
      }
    case ADD_LINK:
      return {
        ...state,
        links: [action.link, ...(state.links || [])],
      }
    case ADD_LINK_IMAGE:
      return {
        ...state,
        links: (state.links || []).map(
          (link, index) =>
            index === action.linkIndex
              ? { ...link, mainImageId: action.ref }
              : link,
        ),
      }
    case ADD_PROMOTION:
      return {
        ...state,
        promotions: [action.promotion, ...(state.promotions || [])],
      }
    case REMOVE_PROMOTION:
      return {
        ...state,
        promotions: filter(
          state.promotions,
          (promotion, index) => index !== action.index,
        ),
      }
    case REMOVE_LINK:
      return {
        ...state,
        links: filter(state.links, (link, index) => index !== action.index),
      }
    case REMOVE_IMAGE_LIST_ITEM:
      return {
        ...state,
        galleryImages: filter(
          state.galleryImages,
          (image, index) => index !== action.index,
        ),
      }
    default:
      return state
  }
}

const createInitState = () => ({})

const dateFieldNames = [
  'appearWhen',
  'validDateFrom',
  'validDateTo',
  'validTimeFrom',
  'validTimeTo',
]



// WEBPACK FOOTER //
// ./src/reducers/portal.js